<template>
    <v-container app fluid class="pt-1">
        <v-row>
            <v-col cols="6" class="pt-1 pb-1">
                <v-icon class="mr-1" color="indigo" size="18">fas fa-tags</v-icon>
                <span class="subtitle-1 mr-2">Insumo:</span>
                <span class="subtitle-1 font-weight-bold">{{ supplySelected.name }}</span>
            </v-col>            
        </v-row>
        <v-row>
            <v-col cols="12" class="pt-1">
                <v-card>
                    <v-card-title class="pt-0 pb-0">
                        <span class="ml-1 pt-3 pb-3 subtitle-1 font-weight-bold w-title-table">Todos los movimientos</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-0 pl-0 pr-0">
                        <v-simple-table dense height="68vh" class="table-kardex">
                            <thead class="table-kardex-head">
                                <tr>
                                    <th class="text-left text-uppercase" rowspan="2">Fecha</th>
                                    <th class="text-left text-uppercase column-hora" rowspan="2">Hora</th>
                                    <th class="text-left text-uppercase column-tipo-movimiento" rowspan="2">Tip. Movimiento</th>
                                    <th class="text-left text-uppercase column-movimiento" rowspan="2">Movimiento</th>
                                    <th class="text-left text-uppercase column-tipo-documento" rowspan="2">Tipo Doc.</th>
                                    <th class="text-left text-uppercase" rowspan="2">Serie</th>
                                    <th class="text-left text-uppercase" rowspan="2">Número</th>
                                    <th class="text-center text-uppercase" colspan="3">Entrada</th>
                                    <th class="text-center text-uppercase" colspan="3">Salida</th>
                                    <th class="text-center text-uppercase" colspan="3">Existencias</th>
                                </tr>
                                <tr>
                                    <th class="text-center text-uppercase">Cant.</th>
                                    <th class="text-center text-uppercase">Costo</th>
                                    <th class="text-center text-uppercase">Total</th>

                                    <th class="text-center text-uppercase">Cant.</th>
                                    <th class="text-center text-uppercase">Costo</th>
                                    <th class="text-center text-uppercase">Total</th>

                                    <th class="text-center text-uppercase">Cant.</th>
                                    <th class="text-center text-uppercase">Costo</th>
                                    <th class="text-center text-uppercase">Total</th>
                                </tr>
                            </thead>

                            <tbody class="table-kardex-body">
                                <tr v-for="kardex in kardexSupply" :key="kardex.id">
                                    <td>{{ kardex.operation_date  | moment("DD/MM/YYYY") }}</td>
                                    <td>{{ kardex.operation_date  | moment("hh:mm a") }}</td>
                                    <td>{{ kardex.type }}</td>
                                    <td>{{ kardex.sub_type }}</td>
                                    <td>{{ kardex.type_document }}</td>
                                    <td>{{ kardex.serie }}</td>
                                    <td>{{ kardex.correlative }}</td>
                                    <td>
                                        <span class="label-quantity-entry" v-if="kardex.type == 'INGRESO'">
                                            {{ kardex.quantity }}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="kardex.type == 'INGRESO'">
                                            {{ kardex.cost | currency('') }}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="kardex.type == 'INGRESO'">
                                            {{ kardex.total | currency('') }}
                                        </span>
                                    </td>
                                    <td>
                                        <span class="label-quantity-output" v-if="kardex.type == 'SALIDA'">
                                            {{ kardex.quantity }}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="kardex.type == 'SALIDA'">
                                            {{ kardex.cost | currency('') }}
                                        </span>
                                    </td>
                                    <td>
                                        <span v-if="kardex.type == 'SALIDA'">
                                            {{ kardex.total | currency('') }}
                                        </span>
                                    </td>
                                    <td>
                                        <span class="label-quantity-stock">{{ kardex.stock }}</span>
                                    </td>
                                    <td>{{ kardex.cost | currency('') }}</td>
                                    <td>{{ (kardex.stock * kardex.cost) | currency('') }}</td>
                                </tr>
                            </tbody>

                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
    name: 'KardexSupply',
    computed: {
        ...mapState('production', [
            'supplies',
            'supplySelected',
            'kardexSupply'
        ])
    },
    methods: {
        ...mapActions('production', [
            'getSupplies',
            'runSetSupplySelected',
            'getKardexBySupply',
            'runsetSupplies'
        ]),
    },
    created () {
        this.getKardexBySupply();
    }
}
</script>

<style scoped>
.table-kardex{
    overflow-y: auto;
}
.table-kardex-head{
    background-color: #f2f2f2 !important;
}

.label-quantity-entry{
    background-color: #43a047;
    color: #ffffff;
    display: block;
    width: 50px;
    text-align: center;
    border-radius: 4px;
}

.label-quantity-output{
    background-color: #e53935;
    color: #ffffff;
    display: block;
    width: 50px;
    text-align: center;
    border-radius: 4px;
}

.label-quantity-stock{
    background-color: #3F51B5;
    color: #ffffff;
    display: block;
    width: 50px;
    text-align: center;
    border-radius: 4px;
}

.label-quantity-merma{
    background-color: #FFC107;
    color: #ffffff;
    display: block;
    width: 50px;
    text-align: center;
    border-radius: 4px;
}

.column-hora{
    width: 70px !important;
    min-width: 70px !important;
}

.column-movimiento{
    max-width: 110px !important;
    min-width: 100px !important;
}

.column-tipo-documento{
    max-width: 110px !important;
    min-width: 100px !important;
}
.table-kardex-body td{
    height: 40px !important;
}

.table-kardex td, .table-kardex th{
    padding: 0 2px !important;
}
</style>